module.exports = __webpack_public_path__ + "static/party2021-b34a0273f6ca13c914402772c28abe68.jpg";